import { IonContent, IonLoading, IonModal } from '@ionic/react';
import React, { useCallback } from 'react';

import { MobileNumber, Verification } from '@/components/auth/signIn';
import { Logo, Padding, ProgressBar } from '@/components/common';
import { SignInProvider, useSignIn } from '@/contexts';
import { SIGN_IN_STEPS } from '@/utils/constants';
import { arrowBackOutline } from 'ionicons/icons';

import './AddAccountModal.css';

interface AddAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  presentingElement?: HTMLElement | undefined;
}

interface AddAccountModalContentProps {
  onClose: () => void;
}

const AddAccountModalContent: React.FC<AddAccountModalContentProps> = ({
  onClose
}) => {
  const { loading, currentStep, setCurrentStep, goBack } = useSignIn();

  const onBack = useCallback(() => {
    if (currentStep === SIGN_IN_STEPS.MOBILE_NUMBER) {
      onClose();
      return;
    }

    const previousStepIndex =
      Object.values(SIGN_IN_STEPS).findIndex((step) => step === currentStep) -
      1;
    const newStep = Object.values(SIGN_IN_STEPS)[previousStepIndex];
    if (newStep) {
      setCurrentStep(newStep);
    }
  }, [currentStep, setCurrentStep, onClose]);

  const renderSignIn = () => {
    const totalSteps = Object.keys(SIGN_IN_STEPS).length;
    const currentStepIndex = Object.values(SIGN_IN_STEPS).indexOf(currentStep);

    const stepComponents = {
      [SIGN_IN_STEPS.MOBILE_NUMBER]: <MobileNumber />,
      [SIGN_IN_STEPS.VERIFICATION]: <Verification />
    };

    return (
      <>
        <ProgressBar
          totalSteps={totalSteps}
          currentProgress={currentStepIndex}
        />
        {stepComponents[currentStep]}
      </>
    );
  };

  return (
    <IonContent>
      <Padding>
        <Logo leftIcon={arrowBackOutline} onClickLeftIcon={onBack} />
        {renderSignIn()}
      </Padding>

      <IonLoading isOpen={loading} message="Loading..." spinner="crescent" />
    </IonContent>
  );
};

const AddAccountModal: React.FC<AddAccountModalProps> = ({
  isOpen,
  onClose,
  presentingElement
}) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      presentingElement={presentingElement}
    >
      <SignInProvider onAfterSignIn={onClose}>
        <AddAccountModalContent onClose={onClose} />
      </SignInProvider>
    </IonModal>
  );
};

export default AddAccountModal;
